import classes from 'classnames';
import React, { memo } from 'react';
import styles from './Selection.module.scss';

export type Props = {
  value: string;
  label: string;
  id: string;
  className?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  name: string;
};

const SelectionMemo = memo(function Selection({
  id,
  value,
  onChange,
  checked,
  className,
  label,
  name,
}: Props) {
  const wrapperStyle = checked ? styles['wrapper-checked'] : styles.wrapper;

  return (
    <div className={classes(className, wrapperStyle)} data-test="selection">
      <label htmlFor={id} className={classes(styles.container)}>
        <input
          className={styles.input}
          id={id}
          onChange={onChange}
          value={value}
          type="radio"
          name={name}
          checked={checked}
          data-test="selection-input"
        />
        <span data-test="selection-label">{label}</span>
      </label>
    </div>
  );
});

export default SelectionMemo;
